import React from 'react'
import Slider from 'react-slick'
import PulseLoader from 'react-spinners/PulseLoader'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowCircleLeft } from '@fortawesome/free-solid-svg-icons/faArrowCircleLeft'
import { faArrowCircleRight } from '@fortawesome/free-solid-svg-icons/faArrowCircleRight'
import { useAppWrapperContext } from '../../context/AppWrapperContext'
import style from './adglare.module.scss'

interface Props {
  path: string
}

const AdGlare = (): JSX.Element => {
  const adGlareValue = useAppWrapperContext()

  const NextArrow = (props: any) => {
    const { onClick, className } = props
    return (
      <div role="presentation" className={className} onClick={onClick}>
        <FontAwesomeIcon className={style.arrow} icon={faArrowCircleRight} />
      </div>
    )
  }

  const PrevArrow = (props: any) => {
    const { onClick, className } = props
    return (
      <div role="presentation" className={className} onClick={onClick}>
        <FontAwesomeIcon className={style.arrow} icon={faArrowCircleLeft} />
      </div>
    )
  }

  const slideSettings = {
    dots: false,
    arrows: true,
    infinite: true,
    fade: true,
    // lazyLoad: true,
    draggable: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  }

  //   const Loading = <PulseLoader size={20} color="#b8b8b8" loading />

  return (
    <div className={style.adsWrapper}>
      {adGlareValue && adGlareValue.response.campaigns ? (
        <div className={style.wrapper}>
          <Slider {...slideSettings}>
            {adGlareValue.response.campaigns.map((item, index) => (
              <a key={index} href={item.creative_data.click_url} alt="">
                <img alt="" src={item.creative_data.image_url} />
              </a>
            ))}
          </Slider>
        </div>
      ) : (
        <div className={style.loading}>
          <PulseLoader size={20} color="#b8b8b8" loading />
        </div>
      )}
    </div>
  )
}

export default AdGlare
